export const SET_AUTH = 'setUser'
export const SET_LOCALSTORE = 'seTLocalstore'

export const PURGE_AUTH = 'logOut'
export const SET_ERROR = 'setError'

export const SET_PROJECTS = 'setProjects'
export const SET_PROJECT = 'setProject'

export const SET_DASHBOARD = 'setDashboard'

export const SET_SIDEBAR = 'setSidebar'
export const SET_NAME_SIDEBAR = 'SET_NAME_SIDEBAR'
export const SET_TABLE = 'setTable'

export const SET_DB_TABLES = 'setDbTables'
export const SET_DB_TABLE =  'setDbTable'

export const SET_TIPO_MENU = 'setTipoMenu'
export const SET_TEMPLATE_OPTIONS = 'setTemplateOptions'
export const SET_TIPO_TEMPLATE_DESKTOP = 'SET_TIPO_TEMPLATE_DESKTOP'
export const SET_PLUGINS_PROJECT = 'SET_PLUGINS_PROJECT'
export const SET_USER_ACCESS = 'FECTH_USER_ACCESS'




// WEBPACK FOOTER //
// ./src/store/mutations.type.js